import { useTranslation } from 'react-i18next';
import Shot, { type ShotName } from './Shot.js';

// Hero demo: three consecutive stories from the Scroll layout swipe up one after another,
// a thumb gesture leads each swipe. Pure CSS (styles.css `.hero-scroller`), the last frame
// repeats the first so the loop is seamless. Under prefers-reduced-motion only the first
// frame is shown and the thumb is hidden.
export const HERO_FRAMES: ShotName[] = ['hero-1', 'hero-2', 'hero-3'];

function ThumbIcon() {
  return (
    <svg viewBox="0 0 48 48" aria-hidden="true" className="h-12 w-12 drop-shadow-lg" fill="none">
      <circle cx="24" cy="24" r="22" fill="rgba(255,255,255,0.18)" stroke="rgba(255,255,255,0.7)" strokeWidth="1.5" />
      <circle cx="24" cy="24" r="9" fill="rgba(255,255,255,0.9)" />
    </svg>
  );
}

export default function HeroScroller() {
  const { t } = useTranslation();
  const frames: ShotName[] = [...HERO_FRAMES, HERO_FRAMES[0]!];
  return (
    <div className="hero-scroller relative h-full w-full" role="group" aria-label={t('landing.hero.demoLabel')}>
      <div className="hero-scroller__track flex h-full w-full flex-col">
        {frames.map((name, i) => (
          <div key={`${name}-${i}`} className="h-full w-full shrink-0" aria-hidden={i > 0 ? true : undefined}>
            <Shot name={name} alt={i === 0 ? t('landing.hero.shotAlt') : ''} width={780} height={1560} eager priority={i === 0} />
          </div>
        ))}
      </div>
      <div className="hero-scroller__thumb pointer-events-none absolute bottom-[22%] right-[14%]" aria-hidden="true">
        <ThumbIcon />
      </div>
    </div>
  );
}
